import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import CommonModal from "./CommonModal";
import {
  buttonName,
  commonValidationMsg,
  createPricingPlan,
  fieldValidation,
  invoiceTab,
  updateStatusModalData
} from "../../locales/en";
import { getCustomerInvoiceStatusApprovalData } from "../../redux/invoiceDetailsSlice";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";
import Style from "./modal.module.scss";
import "./../../assets/scss/common.scss";

const CustomerStatusBulkUpdateApprovalInfo = ({
  isOpen,
  toggle,
  approvalData,
  handleGroupStatusUpdate,
  userQuoteIdsSelected,
  statusNewValue,
  InvoicesData
}) => {
  const dispatch = useDispatch();

  const initialFormData = { comment: "" };

  const [formData, setFormData] = useState(initialFormData);
  const [errorMessage, setErrorMessage] = useState({});

  const handleUpdateApprovalStatus = async () => {
    if (!formData.comment.trim()) {
      setErrorMessage({ comment: fieldValidation?.required });
      return;
    }

    try {
      const payload = {
        quoteIds: userQuoteIdsSelected,
        reason: formData.comment
      };

      const response = await dispatch(
        getCustomerInvoiceStatusApprovalData(payload)
      ).unwrap();

      if (response.status === 200) {
        toggle(false);
        showToast(response.data.message, showToastType.success);
        handleGroupStatusUpdate(statusNewValue);
        setFormData({ comment: "" });
        setErrorMessage({});
        InvoicesData();
      }
    } catch {
      //handle error
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={invoiceTab?.customerInvTable?.errMsg?.item3}
      footerButtons={[
        {
          label: buttonName?.close,
          className: "btn btn-secondary",
          onClick: () => toggle(false)
        },
        {
          label: createPricingPlan?.propertyOptions?.item1,
          className: "btn btn-primary",
          onClick: handleUpdateApprovalStatus
        }
      ]}
    >
      <div className="row">
        {approvalData && (
          <div className="mb-3">
            <div className={Style.modalInputwrap}>
              <p>
                {updateStatusModalData?.sub3} {approvalData?.customer}
                {` to `}
                {approvalData?.requestedAmount}
              </p>
              <p>
                {approvalData?.warning} {approvalData?.availableCredit}
              </p>
            </div>
          </div>
        )}

        <div className="mb-3">
          <div className={Style.modalInputwrap}>
            <label htmlFor="comments" className="mb-1">
              {commonValidationMsg?.wishProced}
            </label>
            <div className={Style.formInput}>
              <textarea
                id="comments"
                name="comment"
                value={formData.comment}
                onChange={(e) => {
                  setFormData({ ...formData, comment: e.target.value });
                  setErrorMessage({});
                }}
                className="form-control height-150"
                rows="6"
                placeholder={updateStatusModalData?.placeholder}
              />

              {errorMessage.comment && (
                <div className="text-danger small">{errorMessage.comment}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

CustomerStatusBulkUpdateApprovalInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  approvalData: PropTypes.object,
  handleGroupStatusUpdate: PropTypes.func.isRequired,
  userQuoteIdsSelected: PropTypes.array,
  statusNewValue: PropTypes.any,
  InvoicesData: PropTypes.func
};

export default CustomerStatusBulkUpdateApprovalInfo;
